import { render, staticRenderFns } from "./c-new-address.vue?vue&type=template&id=f70f4906&scoped=true&"
import script from "./c-new-address.vue?vue&type=script&lang=js&"
export * from "./c-new-address.vue?vue&type=script&lang=js&"
import style0 from "./c-new-address.vue?vue&type=style&index=0&id=f70f4906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70f4906",
  null
  
)

export default component.exports